import { ToDoItem } from './types';

export const countCompleted = (items: ToDoItem[]) =>
  items.reduce((carry, item) => (item.completed ? carry + 1 : carry), 0);
